import React from "react";
import { useTheme } from "@emotion/react";
import {
  Backdrop,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import * as Yup from "yup";
import RadioButtonComponent from "../../components/forms/RadioButtonComponent";
import Form from "../../components/forms/Form";
import InputComponent from "../../components/forms/InputComponent";
import SubmitButton from "../../components/forms/SubmitButton";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { PRODUCT_CREATE_RESET } from "../../constants/productContansts";
import { createProduct } from "../../actions/productActions";
import { CustomSelectComponent } from "../../components/forms/CustomSelectComponent";
import { listcategory } from "../../actions/categoryActions";
import { listStores } from "../../actions/storeActions";
import { listBrand } from "../../actions/brandActions";
import { listAttributes } from "../../actions/attributeActions";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  sku: Yup.string().required("SKU is required"),
  image: Yup.string().required("Image is required"),
  price: Yup.number().required("Price is required"),
  qty: Yup.number().required("Qty is required"),
  description: Yup.string().required("Description is required"),
  store: Yup.string().required("Store is required"),
  brand: Yup.string().required("Brand is required"),
  category: Yup.string().required("Category is required"),
  color: Yup.string().required("Color is required"),
  size: Yup.string().required("Size is required"),
  available: Yup.boolean().required("Available is required"),
});

const AddProduct = () => {
  const dispatch = useDispatch();

  const { palette } = useTheme();
  const navigate = useNavigate();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const productCreate = useSelector((state) => state.productCreate);
  const { loading, error, success } = productCreate;

  const storeList = useSelector((state) => state.storeList);
  const { loading: storeLoading, stores } = storeList;

  const categoryList = useSelector((state) => state.categoryList);
  const { loading: catLoading, categories } = categoryList;

  const brandList = useSelector((state) => state.brandList);
  const { loading: brandLoading, brands } = brandList;

  const attributeList = useSelector((state) => state.attributeList);
  const { loading: attrLoading, attributes } = attributeList;

  useEffect(() => {
    if (!userInfo) {
      navigate("/", { replace: true });
    }
    if (success) {
      dispatch({ type: PRODUCT_CREATE_RESET });
      navigate("/products");
      toast("Product created successfully");
    }
    dispatch(listcategory());
    dispatch(listStores());
    dispatch(listBrand());
    dispatch(listAttributes());
  }, [userInfo, dispatch, navigate, success]);

  const handleSubmit = async ({
    name,
    image,
    sku,
    price,
    qty,
    description,
    store,
    brand,
    category,
    color,
    size,
    available,
  }) => {
    dispatch(
      createProduct({
        name,
        image,
        sku,
        price,
        qty,
        description,
        store,
        brand,
        category,
        attributes: { color, size },
        available,
      })
    );
  };

  return (
    <Container>
      {loading && (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: 10,
          backgroundColor: palette.background.default,
        }}
      >
        {error && <Typography color="error">{error}</Typography>}

        <Typography variant="h5" component="h2">
          Add Product
        </Typography>
        <>
          <Form
            initialValues={{
              name: "",
              sku: "",
              image: "",
              price: "",
              qty: "",
              description: "",
              store: "",
              brand: "",
              category: "",
              color: "",
              size: "",
              available: false,
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            <Grid container spacing={3}>
              <Grid item xs={4}>
                <InputComponent label="name" />
              </Grid>
              <Grid item xs={4}>
                <InputComponent label="sku" />{" "}
              </Grid>
              <Grid item xs={4}>
                <InputComponent label="image" />
              </Grid>
              <Grid item xs={4}>
                <InputComponent label="price" type={"number"} />
              </Grid>
              <Grid item xs={4}>
                <InputComponent label="qty" type={"number"} />
              </Grid>
              <Grid item xs={4}>
                <InputComponent label="description" multiline maxRows={8} />
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <CustomSelectComponent name={"store"} item={stores} />
                </Grid>
                <Grid item xs={4}>
                  <CustomSelectComponent name={"brand"} item={brands} />
                </Grid>
                <Grid item xs={4}>
                  <CustomSelectComponent name={"category"} item={categories} />
                </Grid>
                
                <Grid item xs={6}>
                  <CustomSelectComponent name={"size"} item={attributes} />
                </Grid>
                <Grid item xs={6}>
                  <CustomSelectComponent name={"color"} item={attributes} />
                </Grid>
              </Grid>
              <Grid item xs={6}>
              <RadioButtonComponent name="available" />
              </Grid>

              <SubmitButton title={"Add Product"} />
            </Grid>
          </Form>
        </>
      </Box>
    </Container>
  );
};

export default AddProduct;
